"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "mediaQueries", {
  enumerable: true,
  get: function get() {
    return _breakpoints.mediaQueries;
  }
});
Object.defineProperty(exports, "lceGlobal", {
  enumerable: true,
  get: function get() {
    return _global.lceGlobal;
  }
});
Object.defineProperty(exports, "lceReset", {
  enumerable: true,
  get: function get() {
    return _global.lceReset;
  }
});
Object.defineProperty(exports, "normalize", {
  enumerable: true,
  get: function get() {
    return _global.normalize;
  }
});
exports.default = exports.lceBase = void 0;

var _presets = require("@theme-ui/presets");

var _themeUi = require("theme-ui");

var _toaster = require("./components/toaster");

var _breakpoints = require("./variables/breakpoints");

var _space = require("./variables/space");

var _colors = require("./variables/colors");

var _typography = require("./variables/typography");

var _fontSizes = require("./variables/fontSizes");

var _global = require("./global");

var lceBase = (0, _themeUi.merge)(_presets.base, {
  useCustomProperties: true,
  useBorderBox: true,
  useBodyStyles: true,
  space: _space.space,
  fontSizes: _fontSizes.fontSizes,
  breakpoints: _breakpoints.breakpoints,
  colors: _colors.colors,
  media: _breakpoints.media,
  typography: _typography.typography,
  toaster: _toaster.toaster,
  styles: {
    root: {
      fontFamily: 'body',
      fontWeight: 'body'
    }
  }
});
exports.lceBase = lceBase;
var _default = lceBase;
exports.default = _default;